import { Component } from '@theme/component';
import { prefersReducedMotion } from '@theme/utilities';

/**
 * Rotates the `.show` class across child items on a setInterval.
 * The CSS opacity transition on `.show` items handles the cross-fade.
 *
 * @typedef {object} Refs
 * @property {HTMLElement[]} [items]
 *
 * @extends {Component<Refs>}
 */
class RotatingTextComponent extends Component {
  #current = 0;

  /** @type {number | undefined} */
  #timer = undefined;

  connectedCallback() {
    super.connectedCallback();

    const items = this.refs.items ?? [];
    if (items.length <= 1) return;
    if (prefersReducedMotion()) return;

    this.#timer = window.setInterval(this.#advance, this.#intervalMs);
  }

  disconnectedCallback() {
    super.disconnectedCallback?.();
    if (this.#timer !== undefined) clearInterval(this.#timer);
  }

  get #intervalMs() {
    const seconds = parseFloat(this.dataset.interval ?? '7');
    return Math.max(Number.isFinite(seconds) ? seconds : 7, 0.5) * 1000;
  }

  #advance = () => {
    const items = this.refs.items ?? [];
    const next = (this.#current + 1) % items.length;
    items[this.#current]?.classList.remove('show');
    items[next]?.classList.add('show');
    this.#current = next;
  };
}

if (!customElements.get('rotating-text-component')) {
  customElements.define('rotating-text-component', RotatingTextComponent);
}
